<ng-container *ngIf="content$ | async as teaser">
  <fin-disclaimer [disclaimer]="teaser"></fin-disclaimer>
</ng-container>
